import * as Yup from "yup";

export interface UsernameFormValues {
	username: string;
}

export const usernameValidationSchema = Yup.object({
	username: Yup.string()
		.required("Username is required")
		.max(30, "Username must be at most 30 characters"),
});
